//Users FlexiGrid

//React & Friends
import React, { useState, useEffect, useContext, useRef } from 'react';

import FlexiGrid from '../common/FlexiGrid/FlexiGrid';


//Doublecheck everything below this line. All from old boilerplate table.
import { useLocation, useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

//Contexts
//AuthContext
import { AppContext } from "../Auth/contexts/AppContext"

//CSS Styles
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';

//Datetime formatting
import dayjs from 'dayjs'; //Used with new datetimepickers


//MaterialUI
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';




const UsersFlexiGrid = () => {
	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	/* App Context */
	/* Allows userperms to be used */
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;


	/* ##########################  SEARCH INPUT DEFAULTS  ########################## */
	// These establish the baseline for the page search inputs.
	//Container and Key Sizes for Search Inputs
	const containersizes = "260px";
	const keysizes = "180px";

	var inputdefaults = { 
		firstname: {
			type: "firstname",
			value: "", //Example name parameter from URL
			mode: "like",
			orable: true,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		lastname: {
			type: "lastname",
			value: "", //Example name parameter from URL
			mode: "like",
			orable: true,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		username: {
			type: "username",
			value: "", //Example name parameter from URL
			mode: "like",
			orable: true,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		role: {
			type: "role",
			value: "", //Example name parameter from URL
			mode: "like",
			orable: true,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		email: {
			type: "email",
			value: "",
			mode: "not",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
	};

	/* ########################## Custom Parameters: Modify Per-Controller  ##########################

	 Each new table will likey have very different parameters. Handle them before configuration.

	Concept: We have this really complicated search input system. When a page is linked with URL parameters, let's marshall each 
	key-value pair into new defaults based on input defaults.

	Possibly clear the URL before rendering inputs and page?

				*/

	//This controls how many inputs we need to fill for the page. Often we simply use 4 or 8, but we'll try and modify the code to be able to use any values.
	const minimuminputs = 4;
	const maximuminputs = 4;		

	

	
	const params = new URLSearchParams(useLocation().search);

	const urlparams = Array.from(params.entries());


	//		AUTOCOMPLETEPAIRS
	//      If you are not using auto-complete search inputs, you may simply comment the array inside autocompletepairs.
	// 		This is a special array. It is structured to allow a key-value pair shortcut to pre-fill a search input with label!
	//		Logic below also removes the need to add the search input type - when an autocomplete pair is found our custom array's third argument allows us to understand the search input type!
	//		Database compatibility: Autocompletes are typically driven by the searchinputtype as well, see DBAutoComplete.php
	// 		URL Params Compatiblity: Any link generator will need to follow the pattern of the autocompletepair. In this example, ProductID then Name and always in that order.
	// 
	// 
	// 		The structure of the array of arrays is:
	//		----------------------------------------------------------------------------------------------------------------------------------------------------------------------
	//		keyedby: "ProductID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection. This is often how the DB will load the items.
	//		searchkey: "Name", //This is the column we are searching from the table, often a friendly name
	//		searchinputtype:  The searchinput that we're pre-filling. Having this assigned means we won't ever need to reference it as a URL parameter!
	//		[[keyedby, searchkey, searchinputtype],[keyedby, searchkey, searchinputtype],...]


	const autocompletepairs = [
		//['ProductID', 'Name', 'products'], //This will not only fetch from the DB correctly, but it will render the current value without a DB call!

	]

	const configuredinputs = []; //This is where we'll hold 
	var currentconfiguration = {}; 
	var combine = false;
	//This itterates the parameters in sequential order. We need to have flags to check for pairs...
	for (let i = 0; i < urlparams.length; i++) {
		//With urlparams, 0 is the key, and 1 is the value.
		//Use current entry and check that it is or isn't an auto-complete pair
		for (let j=0; j<autocompletepairs.length; j++){
			if (urlparams[i][0]===autocompletepairs[j][0]){
				//Doublecheck for next value!
				if (urlparams[i+1] && urlparams[i+1][0]===autocompletepairs[j][1]){
					//alert("Found matching: "+autocompletepairs[j][1]);
					currentconfiguration = Object.assign({}, inputdefaults[autocompletepairs[j][2]]); //Source must exist above. This example, we're cloning the 'products' search input.
					//This example is interpereted as : currentconfiguration = Object.assign({}, inputdefaults['products']);
					
					//Check if we should add our new configuration to an existing one.
					combine=false;
					for (var p=0;p<configuredinputs.length; p++){
						console.log(configuredinputs);
						console.log(currentconfiguration);
						if (configuredinputs[p].type===currentconfiguration.type){
							combine = true;
							//Modify existing configured input
							configuredinputs[p].value.push({
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							})
						}
					}

					if (!combine){
						//Override value:
						currentconfiguration.value = [
							{
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							}
						];
						//Push to configured inputs
						configuredinputs.push(currentconfiguration);
					}
					console.log("Autocomplete found for: "+autocompletepairs[j][2]);
					//Since we consumed the second half of the URL parameter for the autocomplete, we skip the next URL entry!
					i++;
				}
			}
		}
	}

	//console.log(configuredinputs);

	//If configured inputs is less than the minimum, we need to fill the remainder with appropriately available search inputs, preset to commonly used ones that aren't already specified in URL parameters!
	//First we'll need a search input priority array:
	var priorityarray = [
		"firstname",
		"lastname",
		"username",
		"email",
		"role"
	];

	//Make a copy of this array so we can use it for resets!
	var resetarray = Object.assign({}, priorityarray);

	var k=0;
	var l=0;
	var finalinputs=[]; //Configure a variable to send to configuration!
	if (configuredinputs.length<minimuminputs){
		for (var k=0; k<configuredinputs.length; k++){
			finalinputs.push(configuredinputs[k]);
			//Loop configured inputs and remove any priority items that are already handled!
			for (var m=0; m<priorityarray.length; m++){
				if (configuredinputs[k].type===priorityarray[m]){
					// console.log("################################################");
					// console.log(priorityarray[m]);
					// console.log(configuredinputs[k]);
					priorityarray.splice(m,1);
				}
			}
		}
	}

	//We can now itterate over the other priority inputs and fill in the next most important ones that weren't already sliced off the array.
	for (k=0; k<priorityarray.length; k++){
		finalinputs.push(inputdefaults[priorityarray[k]]);
	}








	// checkparameters.forEach(checkparameter =>{
	// 	parameterarray = params.getAll(checkparameter);
	// 	if (parameterarray.length) {
	// 		parameterarray.forEach(parameter => {
	// 			// Do something with each name
	// 			console.log(parameter);
	// 			//Create new configuration
	// 			currentconfiguration = Object.assign({}, inputdefaults[checkparameter]); //Source must exist above.
	// 			currentconfiguration.value = parameter;
	// 			configuredinputs.push(currentconfiguration);
	// 		});
	// 	}
	// });



	/* ##########################  Configuration  ########################## */
	//Perms - Be sure endpoints are secure because this certainly isn't. These are for perm driven views, not the perms on data.
	var perms = {
		createPerm:(userPerms['createUserData']===1 ? true : false),
		readPerm:(userPerms['readUserData']===1 ? true : false),
		updatePerm:(userPerms['updateUserData']===1 ? true : false),
		deletePerm:(userPerms['deleteUserData']===1 ? true : false),
	}



	//Grid Configuration
	const configuration = {
		//PAGE OPTIONS
		showtitle:true,
		title: "Users",
		menuitem:"/users",
		menusection:"Admin Settings",
		viewmode:"grid", //Default is "grid" to show grid mode. 
		defaulteditmode:false,

		 
		//DATA OPTIONS
		apiendpoint: "/flexigrid/",
		dbmodel:"User", //or flexproduct, flexorder, etc	
		itemskey:"id",
		nestedrelationships:[
			// 'creationuser',
			// 'updateuser',
			// 'deletionuser',
			// 'product'
		],
		//DB Support items (try to add supports to DB tables when it's helpful)
		softdeletesupport:true,
		creationusersupport:false,
		updateusersupport:false,
		deleteusersupport:false,

		//Datetimes to handle
		datetimes:[
			'updated_at',
			'created_at',
			'lastlogin'
		],



		//TABLE OPTIONS
		tablebordertype: "thin", //open (no borders like on Products), thin (Main tables, darker border), thick (Order Details has all thick and lighter gray border tables)
		showcolumnheaders:true,
		maxrowseditmode:100,
		statusbar:false,
		bonusrow:false,
		minimuminputs:3,
		maximuminputs:3,
		rowsperpage:100,
		rowsperpageoptions:[100, 250, 500],

		//Search Input Settings
		defaultselectinputs: [
			{ value: "firstname", text: "First Name" },
			{ value: "lastname", text: "Last Name" },
			{ value: "username", text: "Username" },
			{ value: "email", text: "Email Address" },
			{ value: "role", text: "Role" },
		
		],
	

		//Keep a copy of the default inputs just in case the user wants to "reset" the page
		inputdefaults:inputdefaults, //ToDo: Change this to final inputs!
		resetarray:resetarray,
		//Send a copy of configuredinputs
		configuredinputs:finalinputs,

		//Search by & order
		orderby: "firstname",
		order: "asc",

		// //Default Search Inputs (up to 8),
		// input1: "Name",
		// input2: "products",
		// input3: "DateTimeAfter",
		// input4: "DateTimeBefore",
		// input5: "components",
		// input6: "Cost <",
		// input7: "NewCheckbox",
		// input8: "SomeSelectable",

		//Columns describe the renderable columns
		columns: [
			{
				field: "Checkbox",
				visible: true,
				columnheader: "maincheckbox",
				currentlyeditable:true,
				render: "maincheckbox", //Special, does not need extended config
				borders:"all",
				columnoption:false,
				columnoptionlabel:"Checkbox"

			},
			{
				field: "firstname", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "First Name",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:45, //Validation....
				render:"textlink", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				linkid:"id",
				linkendpoint:"/user/",
				target:"_blank",
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"First Name"
			},
			{
				field: "lastname", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Last Name",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:45, //Validation....
				render:"textlink", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				linkid:"id",
				linkendpoint:"/user/",
				target:"_blank",
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Last Name"
			},
			{
				field: "username", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Username",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:45, //Validation....
				render:"text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Username"
			},
			{
				field: "email", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Email",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:45, //Validation....
				render:"text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Email Address"
			},
			{
				field: "role", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Role",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {width:"80px"}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:45, //Validation....
				render:"text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Role"
			},
			{
				field: "disabled",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Disabled",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: {width:"85px"}, //Raw inline css
				valuetextalign:"center",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				render: "checkbox",
				validationmethod:"checkbox",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Disabled Status"
			},
			{
				field: "created_at",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Creation",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				render: "datetime",
				datetimeformat:"friendly", //"friendly",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Creation"
			},
			,
			{
				field: "lastlogin",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Last Login",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				render: "datetime",
				datetimeformat:"friendly", //"friendly",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Last Login"
			},
			

		],

		//Controls how edit mode will traverse editable cells.
		taborder:[],

		// buttonsold:{
		// 	Save:{
		// 		visible:true
		// 	},
		// 	PendingSave:{
		// 		visible:true
		// 	},
		// 	AddRow:{
		// 		visible:true
		// 	},
		// 	AddItem:{
		// 		visible:true
		// 	},
		// 	ViewOptions:{
		// 		visible:true
		// 	}
		// }

		buttons: [
			{
				type:"Save",
				text:"Save",
				visible:false,
				perm:(userPerms['updateUser']===1 ? true : false)
			},{
				type:"PendingSave",
				text:"Save",
				visible:false,
				perm:(userPerms['updateDemoData']===1 ? true : false)
			},{
				type:"AddRow",
				text:"Add Row",
				visible:false,
				perm:(userPerms['updateUser']===1 ? true : false)
			},{
				type:"AddItem",
				text:"Add User",
				visible:false,
				perm:(userPerms['updateUser']===1 ? true : false)
			},{
				type:"ViewOptions",
				text:"View Options",
				visible:true,
				perm:true,
				config:{
					expandsearch:false,
					expandall:false,
					editmode:false
				}
			},{
				type:"EditItems",
				text:"Edit Items",
				visible:false,
				perm:(userPerms['updateUser']===1 ? true : false)
			},{
				type:"Export",
				text:"Export",
				visible:false,
				perm:false
			},{
				type:"ItemList",
				text:"Item List",
				visible:false,
				perm:false,
				title:"Item List",
				description: "Filter grid results by item <Name, ID, Sku, etc>.",
				itemlistkey:"Name"
			},{
				type:"Reset",
				text:"Reset",
				visible:true,
				perm:true
			}
		],

		bulkeditcolumns: [
			{
				field:"Name",
				label:"Name",
				changetype:"text",
				maxlength:15,
				minlength:3
			},{
				field:"Cost",
				label:"Cost",
				changetype:"float", //Float, you can specify if you want below-zero values.
				maxval:1000000000,
				minval:0,
				precision:4
			},{
				field:"Price",
				label:"Price",
				changetype:"float",
				maxval:1000000000,
				minval:0
			},{
				field:"PositiveInteger",
				label:"Positive Integer",
				changetype:"integer", //Positive Integer
				maxval:1000000000,
				minval:0
			},{
				field:"SomeBoolean", 
				label:"Some Boolean",
				changetype:"select",
				menuitems:
				[
					{
						value:0,
						label:"No"
					},{
						value:1,
						label:"Yes"
					},{
						value:null,
						label:"Unknown (null, if capable)"
					}
				],
				default:{
					value:0,
					label:"No"
				},
			},{
				field:"NewCheckbox", 
				label:"New Checkbox",
				changetype:"checkbox", //Special bool to show checkbox
				default:false,
			},{
				field:"Date", 
				label:"Date",
				changetype:"date", //Date
				default:false, //Possibly send a default? "now"? "1yrago"? //For now false, no default.
			},{
				field:"DateTime", 
				label:"Date Time",
				changetype:"datetime", 
				default:false,
			},{
				field:"SomeSelectable", 
				label:"Some Selectable Custom",
				changetype:"customselect",
				customoptions:[
					<MenuItem value={0}>
								<em>Zero</em>
							</MenuItem>,
							<MenuItem value={null}>None - null</MenuItem>,
							<MenuItem value="">Blank</MenuItem>,
							<MenuItem value={10}>10</MenuItem>,
							<MenuItem value={"Adam"}>
								<div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#45b84a", padding: "2px 5px 0px 5px" }}>Adam Taylor</div>
							</MenuItem>,


							<MenuItem value={"A"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#45b84a", padding: "2px 5px 0px 5px" }}>Grade A</div></MenuItem>,
							<MenuItem value={"B"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#ccb136", padding: "2px 5px 0px 5px" }}>Grade B</div></MenuItem>,
							<MenuItem value={"C"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#ce823e", padding: "2px 5px 0px 5px" }}>Grade C</div></MenuItem>,
							<MenuItem value={"Repair"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#e9523a", padding: "2px 5px 0px 5px" }}>Repair</div></MenuItem>,
							<MenuItem value={"Scrap"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#777", padding: "2px 5px 0px 5px" }}>Scrap</div></MenuItem>,
							<MenuItem value={"Unknown"}><div style={{ borderRadius: "5px", color: "#FFF", backgroundColor: "#999", padding: "2px 5px 0px 5px" }}>Unknown</div></MenuItem>,
				],
				defaultvalue:false,
			},{
				field:"ProductID",
				label:"Product",
				changetype:"autocomplete",
				searchby:"Name",
				searchtype:"products",
				saveas:"ProductID",
				optionkey:"ProductID", //Since field and saveas aren't always unique values, they're no good for keys we'd like to use from the DB
				autocompletelimit:30,
				debounce:1000,
				childrelationship:true,
				nestedmodel:"product",
				defaultvalue:{
					key:uuidv4(),
					Name:"Default Product",
					ProductID:0
				}
			},{
				field:"DateTime", 
				label:"Date Time",
				changetype:"datetime",
				defaultvalue:new dayjs(),
			},{
				field:"DeleteItems",
				label:"Delete Items",
				changetype:"deleteitems"
			}

		],

		exportoptions:{
			limit:10000,
			exportmessage: "Exports of search results will be limited to your selection or the first "+10000+" rows of your current search.",
			filename:"BasicTableCSV",
			columns: [
				{ column: "ID", label: "ID" },
				{ column: "Name", label: "Name" },
				{ column: "ProductID", label: "ProductID" },
				{ column: "product.Name", label: "Product Name" },
				{ column: "Cost", label: "Cost"},
				{ column: "Price", label: "Price"},
				{ column: "PositiveInteger", label: "PositiveInteger"},
				{ column: "SomeBoolean", label: "SomeBoolean"},
				{ column: "NewCheckbox", label: "NewCheckbox"},
				{ column: "DateTime", label: "Date", dateFormat: "YYYY-MM-DD HH:mm"},
			],

			exporttypes:[
				{label:"Simple",
					removevalues:[
						'ID'
					]
				}
			]
		}
	}





	/* 
				░█████████                               ░██                     
				░██     ░██                              ░██                     
				░██     ░██  ░███████  ░████████   ░████████  ░███████  ░██░████ 
				░█████████  ░██    ░██ ░██    ░██ ░██    ░██ ░██    ░██ ░███     
				░██   ░██   ░█████████ ░██    ░██ ░██    ░██ ░█████████ ░██      
				░██    ░██  ░██        ░██    ░██ ░██   ░███ ░██        ░██      
				░██     ░██  ░███████  ░██    ░██  ░█████░██  ░███████  ░██                                                                                                                 
	*/

	return (<FlexiGrid configuration={configuration} classes={classes} perms={perms}/>);
}

export default UsersFlexiGrid;